import { useRef } from 'react'

export const useScrollToElement = () => {
  const element = useRef<HTMLDivElement>(null)

  const handleScrollToElement = () => {
    if (!element.current) return

    element.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return { element, handleScrollToElement }
}
